import { Component, ElementRef, Input, Renderer2 } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { FieldsEditorActionManagerService } from '../../fields-editor/fields-editor-action-manager.service'
import { FieldPlaceholderComponent } from '../field-placeholder.component'
import { SignFieldType } from '@tokeet-frontend/signature'

@Component({
  selector: 'app-initials-placeholder',
  templateUrl: './initials-placeholder.component.html',
  styleUrls: ['./initials-placeholder.component.scss', '../global-fields.scss'],
})
export class InitialsPlaceholderComponent extends FieldPlaceholderComponent {
  type = SignFieldType.Initials

  @Input() label: string
  @Input() required = true

  disableCustomFont = true

  constructor(
    render: Renderer2,
    fb: FormBuilder,
    elementRef: ElementRef,
    actionManager: FieldsEditorActionManagerService
  ) {
    super(render, fb, elementRef, actionManager)
  }
}
